var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Bullet"},[_c('Icon',{attrs:{"icon":_vm.icon,"size":38,"color":"primary"}}),_c('p',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }